import { render, staticRenderFns } from "./IncSuggestedProducts.vue?vue&type=template&id=ab41163c"
import script from "./IncSuggestedProducts.vue?vue&type=script&lang=js"
export * from "./IncSuggestedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports